/**
 * Section 스타일
 * @description 화면의 가로 리듬을 정하는 자리. 스크린 껍데기가 좌우를 소유하지 않기 때문에
 *   섹션이 대신 맡는다. 세로는 다루지 않는다 — 섹션 사이 간격은 담는 쪽이 `gap` 으로 준다.
 *
 *   `sm`·`lg` 는 `globals.css` 의 `--fw-inset-*` 를 읽는다 — 폰 폭에서 8/16 이고 넓은
 *   화면에서는 같은 축이 함께 커진다.
 */
import { cva } from "class-variance-authority";

export const sectionStyles = cva("w-full", {
  variants: {
    padding: {
      none: "",
      sm: "px-[var(--fw-inset-tab)]",
      lg: "px-[var(--fw-inset-screen)]",
    },
  },
  defaultVariants: { padding: "lg" },
});
